// Run on page load
document.addEventListener('DOMContentLoaded', (e) => {
	cardVideo();
	soldOutVariant();
});

function cardVideo() {
  document.addEventListener('mouseover', (e) => {
    const wrapper = e.target.closest('.card-wrapper');
    const video = wrapper?.querySelector('video');
    if (!video) return;
    if (video.readyState === 0) video.load();
    video.play();
  });

  document.addEventListener('mouseout', (e) => {
    const wrapper = e.target.closest('.card-wrapper');
    const video = wrapper?.querySelector('video');
    if (!video) return;
    video.pause();
  });
}

/**
 * SOLD OUT support for variations 
 */
function soldOutVariant() {
	document.addEventListener('change', function (e) {
		if (e.target.classList.contains('select__select')) {
			const option = e.target.options[e.target.selectedIndex];
			const status = option.dataset.status;
			const value = option.value;

			let btns = [];
			if (document.body.classList.contains('product')) {
				btns = document.querySelectorAll('.product-form .button');
			} else {
				const form = e.target.closest('form');
				btns = form.querySelectorAll('.button');

			}
			if (status === 'sold-out') {
				btns[0].classList.add('hidden');
				btns[1].classList.remove('hidden');
				btns[1].setAttribute('data-variant-id', value);
			} else if (status === 'available') {
				btns[0].classList.remove('hidden');
				btns[1].classList.add('hidden');
			}
		}
	})
}
(function () {
  var block = document.getElementById('shopify-block-AVEh3L3lLb0huSG52R__yotpo_loyalty_rewards_rewards_module_app_block_bnLjBe');
  var section = document.getElementById('shopify-section-template--19302747996222__177634477240b2074d');
  if (!block || !section) return;

  var loader = document.createElement('div');
  loader.className = 'yotpo-block-loader';
  loader.innerHTML =
    '<div class="loading__spinner">' +
      '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">' +
        '<circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>' +
      '</svg>' +
    '</div>';
  section.prepend(loader);

  var QUIET_MS = 500;
  var MAX_WAIT_MS = 8000;
  var quietTimer, ready = false;

  function markReady() {
    if (ready) return;
    ready = true;
    block.classList.add('yotpo-ready');
    section.classList.add('yotpo-ready');
    observer.disconnect();
    clearTimeout(quietTimer);
  }

  var observer = new MutationObserver(function () {
    clearTimeout(quietTimer);
    quietTimer = setTimeout(markReady, QUIET_MS);
  });
  observer.observe(block, { childList: true, subtree: true });

  // Hard ceiling only — nothing fires until the observer sees real content
  setTimeout(markReady, MAX_WAIT_MS);
})();